import { StockItem } from '@anm/api/modules/stocks';
import { Omit } from 'helpers';

import { LIST_LIMIT } from '.';

type ListProps = {
  items: StockItem[];
  columnCount: number;
};

const getMixedStock = ({
  items
}: Omit<ListProps, 'columnCount'>): StockItem[] => {
  const videoStockList = items.filter(el => el.type === 'STOCK_VIDEO');
  const imageStockList = items.filter(el => el.type === 'STOCK_IMAGE');

  const result = [...Array(LIST_LIMIT)].reduce((acc, _, index) => {
    const video = videoStockList[index];
    const image = imageStockList[index];

    video && acc.push(video);
    image && acc.push(image);

    return acc;
  }, [] as StockItem[]);

  return result;
};

const getStocksCount = ({ items }: ListProps): number =>
  items.length < LIST_LIMIT ? items.length : LIST_LIMIT;

const getStrickRowList = ({ items, columnCount }: ListProps): StockItem[] => {
  const count = Math.ceil(items.length / columnCount) * columnCount - 1;

  return items.slice(0, count);
};

export const getStockList = (
  items: StockItem[],
  columnCount: number
): StockItem[] => {
  const mixedList = getMixedStock({ items });
  const stocksCount = getStocksCount({ columnCount, items: mixedList });
  const cuttedList = mixedList.slice(0, stocksCount);

  const strickRowList = getStrickRowList({ columnCount, items: cuttedList });

  return strickRowList;
};
